<!-- Generate Form -->
@if ((nodeSharedFacade.isBlock$ | async) === true) {
  <!-- Chapter Main Settings PDF -->
  <div class="flex flex-column mb-4 row-gap-2">
    <div class="flex align-items-center gap-2">
      @if (isGenerating()) {
          <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
      } @else {
        @if ({
          blocked: (historySharedFacade.canSave$ | async) || false
        }; as pdfGeneration) {
          <medsurf-design-input-menu name="pdf_menu"
            [label]="'global.pdf_generate'"
            [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.WHITE"
            [blockUi]="[ {blocked: pdfGeneration.blocked, iconClass: 'warning'} ]"
            [items]="pdfMenuItems"></medsurf-design-input-menu>

          @if ((historySharedFacade.canSave$ | async)) {
            <small>{{ 'global.save_all_changes_before_generating' | translate }}</small>
          }
        }
      } 
    </div>
    @if ({
      viewer: nodeSharedFacade.currentSelectedPageViewerPdf$ | async,
      author: nodeSharedFacade.currentSelectedPageAuthorPdf$ | async
    }; as pdfs) {
      <div class="flex flex-wrap gap-2">
        @if (pdfs.viewer) {
          <button medsurf-design-input-button
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PDF_DOWNLOAD"
            (click)="downloadPdf(pdfs.viewer, 'viewer')">
            <span [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PDF"></span>
            <div>
              <small>{{ pdfs.viewer.editedAt | date_shared }}</small><br>
              <strong>Viewer | {{ pdfs.viewer.name }}</strong>
            </div>
          </button>
        }
        @if (pdfs.author) {
          <button medsurf-design-input-button
            [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PDF_DOWNLOAD"
            (click)="downloadPdf(pdfs.author, 'author')">
            <span [class]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.PDF"></span>
            <div>
              <small>{{ pdfs.author.editedAt | date_shared }}</small><br>
              <strong>Author | {{ pdfs.author.name }}</strong>
            </div>
          </button>
        }
      </div>
    }
  </div>
}
     
